export const endpoints = {
    projectGroup: '/api/position-monitoring/projectgroup',
    projectGroupById: (id: number) => `/api/position-monitoring/projectgroup/${id}`,
}
